import { render, staticRenderFns } from "./checkExpress.vue?vue&type=template&id=56c556e8&scoped=true&"
import script from "./checkExpress.vue?vue&type=script&lang=js&"
export * from "./checkExpress.vue?vue&type=script&lang=js&"
import style0 from "./checkExpress.vue?vue&type=style&index=0&id=56c556e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c556e8",
  null
  
)

export default component.exports